<template>
  <div>
    <vx-card>
      <div class="flex justify-end">
        <vs-button @click="$router.push({ name: 'org_management_users' })" color="danger" type="filled" icon-pack="feather"
          icon="icon-x" class="mr-4">Cancel</vs-button>
        <vs-button color="#009FB7" type="filled" icon-pack="feather" icon="icon-save"
          @click.prevent="submitForm">Save</vs-button>
      </div>

      <div class="pt-8">
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Username</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="username" />
            <span class="text-danger text-sm" v-show="error.username != ''">{{ error.username }}</span>
          </div>
          <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
            <span>Company</span>
          </div>
          <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
            <vs-select v-model="company" class="w-full select-large">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in listCompany"
                class="w-full" />
            </vs-select>
            <span class="text-danger text-sm" v-show="error.company != ''">{{ error.company }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Password</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="password" v-model="password" />
            <span class="text-danger text-sm" v-show="error.password != ''">{{ error.password }}</span>
          </div>
          <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
            <span>First Name</span>
          </div>
          <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="first_name" />
            <span class="text-danger text-sm" v-show="error.first_name != ''">{{ error.first_name }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Role</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-select v-model="role" class="w-full select-large">
              <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in roles"
                class="w-full" />
            </vs-select>
            <span class="text-danger text-sm" v-show="error.role != ''">{{ error.role }}</span>
          </div>
          <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
            <span>Last Name</span>
          </div>
          <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="last_name" />
            <span class="text-danger text-sm" v-show="error.last_name != ''">{{ error.last_name }}</span>
          </div>
        </div>
        <div v-if="role == 1" class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Email</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="email" v-model="email" />
            <span class="text-danger text-sm" v-show="error.email != ''">{{ error.email }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Country</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="country" disabled />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Street 1</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-3/4 w-full">
            <vs-input class="w-full" type="text" v-model="street1" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Street 2</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-3/4 w-full">
            <vs-input class="w-full" type="text" v-model="street2" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>City</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="city" />
          </div>
          <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
            <span>State/Province/Region</span>
          </div>
          <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="province" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col md:flex md:items-center sm:w-1/4 md:w-1/4 w-full">
            <span>Zip/Postal Code</span>
          </div>
          <div class="vx-col sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="zip" />
          </div>
          <div class="vx-col mt-6 md:mt-0 sm:w-1/4 md:w-1/4 w-full md:pr-10 items-center md:flex md:justify-end">
            <span>Phone</span>
          </div>
          <div class="vx-col sm:mt-6 md:mt-0 sm:w-3/4 md:w-1/4 w-full">
            <vs-input class="w-full" type="text" v-model="phone" />
          </div>
        </div>
        <div class="font-bold">
          Site Access
        </div>
        <span class="text-danger text-sm" v-show="error.site_access != ''">{{ error.site_access }}</span>
        <div class="vx-row">
          <div class="vx-col md:w-1/4">
            <table class="table-site-access w-full">
              <tr class="bg-grey">
                <td class="text-center w-2"><vs-checkbox v-model="accessAll"></vs-checkbox></td>
                <th colspan="2">Site Name</th>
              </tr>
              <tr :key="idx" v-for="(acc, idx) in siteAccess">
                <td class="text-center w-2"><vs-checkbox v-model="acc.checked"></vs-checkbox></td>
                <td>{{ acc.title }}</td>
                <td>
                  <a v-if="isEdit" href="javascript:void(0)"
                    @click.prevent="openOtherAccessModal(acc.siteId)"><feather-icon icon="ArrowRightIcon" /></a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </vx-card>
    <Modal :show="showOtherAccessModal" :order="2" size="sm" centered :close-by-backdrop="false"
      @close="closeOtherAccessModal">
      <div class="bg-white flex flex-col rounded">
        <div class="flex justify-between px-4 pt-4">
          <span class="text-lg font-bold uppercase">Other Access</span>
          <a @click.prevent="closeOtherAccessModal" href="javascript:void(0)"><feather-icon icon="XIcon" /></a>
        </div>
        <div class="p-4" v-if="cameras.length > 0">
          <OtherAccessForm :key="selectedSiteId" :edit="false" v-model="cameras" @save="saveUserCameraAccess" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/modal/Modal.vue";
import OtherAccessForm from "./other_access_tree.vue";
import api from "@/api";
export default {
  data() {
    return {
      isEdit: false,
      id: '',
      username: '',
      password: '',
      company: '',
      companySelected: null,
      country: 'Indonesia',
      first_name: '',
      last_name: '',
      role: '',
      roles: [{
        text: ' -- Select Role --',
        value: ''
      }, {
        text: 'Admin',
        value: 1
      }, {
        text: 'User',
        value: 2
      }],
      accessAll: false,
      siteAccess: [],
      listCompany: [],
      selectedSiteAccess: [],
      street1: '',
      street2: '',
      city: '',
      province: '',
      zip: '',
      phone: '',
      email: '',
      error: {
        username: '',
        password: '',
        company: '',
        first_name: '',
        last_name: '',
        role: '',
        email: '',
        site_access: ''
      },
      showOtherAccessModal: false,
      selectedSiteId: '',
      cameras: []
    }
  },
  components: { Modal, OtherAccessForm },
  watch: {
    accessAll: function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.siteAccess.map(x => x.checked = newVal);
      }
    }
  },
  created() {
    if (this.$route.name == 'org_management_users_add') {
      this.$store.dispatch('updateCurrentUser', null)
    }
    if (this.$route.name == 'org_management_users_update') {
      this.isEdit = true
    }
  },
  mounted() {
    const storeData = this.$store.state.currentUser
    this.getCompany()
    this.getSiteLists()
    //this.getRoles()

    if (storeData != null) {
      this.city = storeData.user.city
      this.company = storeData.user.companyId
      this.country = storeData.user.country
      this.username = storeData.user.email
      this.first_name = storeData.user.firstname
      this.id = storeData.user.id
      this.last_name = storeData.user.lastname
      this.password = storeData.user.password
      this.phone = storeData.user.phone
      this.zip = storeData.user.postalCode
      this.province = storeData.user.region
      this.role = storeData.user.roleId
      this.street1 = storeData.user.street1
      this.street2 = storeData.user.street2
      this.username = storeData.user.username
      this.email = storeData.user.email || ''

      storeData.siteAccess.forEach((site) => {
        this.selectedSiteAccess.push(site.siteId)
      })
    }
  },
  methods: {
    getCompany() {
      this.$vs.loading()
      api.companies()
        .then(result => result.data)
        .then(data => {
          if (data.status) {
            let opts = [{
              value: '',
              text: '-- Select Company --'
            }]
            data.data.map(d => {
              opts.push({
                value: d.id,
                text: d.name
              })
            })
            this.listCompany = opts
          }
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        });
    },
    getSiteLists() {
      api.sites()
        .then(result => result.data)
        .then(data => {
          if (data.status) {
            let opts = []
            data.data.map(d => {
              const isChecked = this.selectedSiteAccess.length > 0 && this.selectedSiteAccess.indexOf(d.id) > -1
              opts.push({
                siteId: d.id,
                title: d.name,
                checked: isChecked
              })
            })
            this.siteAccess = opts
          }
        })
        .catch((e) => {
          console.log(e)
        });
    },
    submitForm() {
      // reset error message
      this.error = {
        username: '',
        password: '',
        company: '',
        first_name: '',
        last_name: '',
        role: '',
        email: '',
        site_access: ''
      }

      if (!this.formValidated()) {
        return;
      }

      this.$vs.loading()
      const postParams = {
        user: {
          username: this.username,
          password: this.password,
          email: this.role == 1 ? this.email : this.username,
          firstname: this.first_name,
          lastname: this.last_name,
          administrator: 0,
          statusId: 1,
          companyId: this.company,
          roleId: this.role,
          country: this.country,
          street1: this.street1,
          street2: this.street2,
          city: this.city,
          region: this.province,
          phone: this.phone,
          postalCode: this.zip
        },
        siteAccess: this.siteAccess.filter(d => d.checked === true)
      };
      if (this.isEdit) {
        postParams.user.id = this.id
      }
      api.saveUser(postParams, this.isEdit)
        .then((result) => result.data)
        .then((data) => {
          this.$vs.loading.close()
          if (!data.status) {
            this.$vs.notify({
              title: 'Error',
              text: data.message,
              color: 'danger',
              position: 'bottom-center'
            })
          } else {
            this.$vs.notify({
              title: 'Success',
              text: 'Success update camera',
              color: 'success',
              position: 'bottom-center'
            })
            setTimeout(() => {
              this.$router.push({ name: 'org_management_users' })
            }, 500)
          }
        })
        .catch((e) => {
          console.log(e)

          this.$vs.notify({
            title: 'Failed',
            text: 'Update data failed',
            color: 'danger',
            position: 'bottom-center'
          })

          this.$vs.loading.close()
        });
    },
    formValidated() {
      let error = 0
      if (this.username == '') {
        this.error.username = 'Username is required'
        error++
      }
      if (this.password == '') {
        this.error.password = 'Password is required'
        error++
      }
      if (this.company == '') {
        this.error.company = 'Company is required'
        error++
      }
      if (this.first_name == '') {
        this.error.first_name = 'First name is required'
        error++
      }
      if (this.last_name == '') {
        this.error.last_name = 'Last name is required'
        error++
      }
      if (this.role == '') {
        this.error.role = 'Please select role'
        error++
      }
      if (this.role == 1 && this.email == '') {
        this.error.email = 'Email is required for Admin role'
        error++
      }
      if (this.role == 1 && this.email != '' && !this.isValidEmail(this.email)) {
        this.error.email = 'Please enter a valid email address'
        error++
      }

      const checkedSiteAccess = this.siteAccess.filter(d => d.checked === true)
      if (checkedSiteAccess.length === 0) {
        this.error.site_access = 'Please at least 1 site access'
        error++
      }
      return error === 0
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
    closeOtherAccessModal() {
      this.showOtherAccessModal = false
    },
    openOtherAccessModal(id) {
      console.log(id)
      this.selectedSiteId = id
      this.getCameraAccessPerSite(id)
      this.showOtherAccessModal = true
    },
    getCameraAccessPerSite(siteId) {
      let params = {
        siteId: siteId
      }

      this.$vs.loading()
      this.cameras = []
      api.getAksesCameraPerSite(params)
        .then(result => result.data)
        .then(data => {
          if (data.status) {
            this.cameras = data.data
          }
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        });
    },
    saveUserCameraAccess() {
      this.$vs.loading()
      api.saveAksesCameraPerSite({
        siteId: this.selectedSiteId,
        aksesCameraArea: this.cameras
      })
        .then(result => result.data)
        .then(data => {
          console.log(data)
          // if (data.status) {
          //   this.cameras = data.data
          // }
          this.$vs.loading.close()
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        });
    }
  }
}
</script>

<style scoped>
.table-site-access td {
  padding: 5px;
}
</style>